class RecipientForm extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.fields = this.querySelector('.recipient-fields');
    this.emailInput = this.querySelector('input[type="email"]');
    this.messageInput = this.querySelector('textarea[name="properties[Message]"]');
    this.messageCounter = this.querySelector(
      '.recipient-form-field-label span'
    );

    this.inputs = this.querySelectorAll(
      '.recipient-fields input, .recipient-fields textarea'
    );

    this.controlInput = this.querySelector(
      'input[name="properties[__shopify_send_gift_card_to_recipient]"][type="hidden"]'
    );
    this.timezoneInput = this.querySelector(
      'input[name="properties[__shopify_offset]"]'
    );

    this.addToCartButton = document.querySelector('[data-js="add-to-cart"]');

    this.EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  }

  connectedCallback() {
    this.checkbox.disabled = false;

    this.updateState(this.checkbox.checked);
    this.updateAddToCartState();
    this.updateMessageCounter();

    this.checkbox.addEventListener('change', () => {
      this.updateState(this.checkbox.checked);
      this.updateAddToCartState();
    });

    this.checkbox.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.checkbox.click();
    });

    this.inputs.forEach((input) => {
      input.addEventListener('input', () => {
        this.updateAddToCartState();
        if (input === this.messageInput) {
          this.updateMessageCounter();
        }
      });
    });
  }

  updateState(isEnabled) {
    this.fields.hidden = !isEnabled;
    this.checkbox.setAttribute('aria-expanded', String(isEnabled));

    this.inputs.forEach((input) => {
      input.disabled = !isEnabled;
    });

    this.controlInput.disabled = !isEnabled;

    this.timezoneInput.disabled = !isEnabled;
    this.timezoneInput.value = isEnabled
      ? new Date().getTimezoneOffset().toString()
      : '';
  }

  isEmailValid() {
    return this.EMAIL_REGEX.test(this.emailInput.value.trim());
  }

  updateAddToCartState() {
    if (!this.checkbox.checked) {
      this.addToCartButton.removeAttribute('disabled');
      return;
    }

    if (!this.isEmailValid()) {
      this.addToCartButton.setAttribute('disabled', 'disabled');
    } else {
      this.addToCartButton.removeAttribute('disabled');
    }
  }

  updateMessageCounter() {
    if (!this.messageInput || !this.messageCounter) return;

    const max = parseInt(this.messageInput.getAttribute('maxlength'), 10);
    const current = this.messageInput.value.length;
    const remaining = max - current;

    this.messageCounter.textContent = `${remaining} characters left`;
  }
}

customElements.define('recipient-form', RecipientForm);
